import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../../app/routes";
import TaskItem from "./Tasks/TaskItem";

export default function Sessions() {
  let [tasks, setTasks] = useState([]);
  let [loader, setLoader] = useState(true);

  useEffect(() => {
    axios.post(routes.api.coaches.tasks).then((resp) => {
      setTasks(resp.data);
      setLoader(false);
    });
  }, []);

  const removeTask = (id) => {
    let filtered = tasks.filter(function (value, index, arr) {
      return value.id != id;
    });
    setTasks(filtered);
  };

  return (
    <>
      {loader && (
        <div className="wait-loader">
          <i className="fa fa-spinner fa-spin green"></i>
        </div>
      )}
      {tasks.length == 0 && !loader && (
        <div className="empty-block">
          Your tasks and sessions will appear here
        </div>
      )}
      {tasks.length > 0 && !loader && (
        <ul>
          {tasks.map((value, index) => {
            return (
              <li key={index}>
                <TaskItem removeTask={removeTask} {...value} />
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
